import React, { useContext, useEffect, useRef, useState } from "react";
import { APIConstants, CommonAPIConstants, formatDOSDate } from '../utilities/Constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash, faFilePdf } from '@fortawesome/free-regular-svg-icons'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { toast } from "react-toastify";
import { useDispatch } from 'react-redux';
import { json, useSearchParams } from "react-router-dom"
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom'
import DatePicker from 'react-datepicker';
import { format } from "date-fns";

import Appointments from "../components/FilerAppointment"

import debounce from "lodash.debounce";

const AppointmentSection = () => {

  const [searchParams] = useSearchParams();
  const patientId = searchParams.get('patientId');
  const autoSaveRefs = useRef({});

  const [selectedInsurance, setSelectedInsurance] = useState([]); //for primary
  const [insurance, setInsurance] = useState([]) //for all
  const [selectedSecondaryIns, setSelectedSecondaryIns] = useState([]); //for secondary
  const [locations, setLocations] = useState([]);
  const [selected, setSelected] = useState("primary");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [address, setAddress] = useState("");
  const [cell, setCell] = useState("");
  const [zip, setZip] = useState("");
  const [isShowPswd, setIsShowPswd] = useState(false);
  const [payerData, setPayerData] = useState("");
  const [benefitData, setBenefitData] = useState("");
  const [objProviderData, setobjProviderData] = useState("");
  const [receiverData, setReceiverData] = useState("");
  const [objPatData, setobjPatData] = useState("");
  const [subscriberData, setSubscriberData] = useState("");
  const [addisubscriberData, setAddiSubscriberData] = useState("");
  const [coInsurance, setCoInsurance] = useState("");
  const [coPayment, setCoPayment] = useState("");
  const [deductibleDta, setDeductibleDta] = useState("");
  const [eligibilityData, setEligibilityData] = useState("");
  const [appointmentDetails, setAppointmentDetails] = useState([])
  const [PADetails, setPADetails] = useState([])
  const [DOSDate, setDOSDate] = useState(new Date())
  const [error, setError] = useState("")

  const [startDate, setStartDate] = useState(''); // State to store start date
  const [endDate, setEndDate] = useState('');     // State to store end date
  const [selectDOSDate, setSelectDOSDate] = useState('');
  const [isStartOpen, setIsStartOpen] = useState(false);
  const [isEndOpen, setIsEndOpen] = useState(false);
  const [isDosOpen, setIsDosOpen] = useState(false);

  const [isSaving, setIsSaving] = useState(false);

  const [notes, setNotes] = useState('');
  const [alerts, setAlerts] = useState('')
  const [rowState, setRowState] = useState({});
  const [insID, setInsID] = useState('');

  const [isLoading, setIsLoading] = useState(false);
  const [isInStatus, setIsInStatus] = useState('');
  const [city, setCity] = useState('');
  const [stateName, setStateName] = useState('');
  const [zipError, setZipError] = useState('');
  const [isDuplicate, setIsDuplicate] = useState(false);
  const [isDuplicateData, setIsDuplicateData] = useState([]);



  const [errorMessages, setErrorMessages] = useState({
    cell: "",
    address: "",
    zip: "",
  });
  const [saveStatus, setSaveStatus] = useState({
    cell: null,
    address: null,
    zip: null,
  });
  const [isOpen, setIsOpen] = useState(false)
  // const { mostRecentPrevious, mostRecentNext } = Appointments({
  //   appointmentDetails,
  //   isCounselor
  // });



  const userData = useSelector((state) => state.user.user);

  const dispatch = useDispatch();



  const { id } = useParams();
  const PatientID = localStorage.setItem("PatientID", id);



  var userPracticeID = userData ? userData.practiceID : null;

  var userId = userData ? userData.userID : null;


  const sAuthToken = useSelector((state) => state.user.user.sAuthToken);

  //console.log("Appointment ID>>>>>>>>>>>>>", id);

  const DemoGraphyData = useSelector((state) => state.user.demoDetails);


  useEffect(() => {
    if (DemoGraphyData?.Address1) {
      setAddress(DemoGraphyData.Address1);
    }

    if (DemoGraphyData?.Zip) {
      setZip(DemoGraphyData.Zip);
    }

    if (DemoGraphyData?.CellMainPhone) {
      setCell(DemoGraphyData.CellMainPhone);
    }

    if (DemoGraphyData?.LocationID) {
      setSelectedLocation(DemoGraphyData.LocationID);
    }
    if (DemoGraphyData?.CityName) {
      setCity(DemoGraphyData.CityName)
    }
    if (DemoGraphyData?.StateName) {
      setStateName(DemoGraphyData.StateName)
    }

  }, [DemoGraphyData]);




  const extractDate = (appointmentDate) => {
    const date = new Date(appointmentDate); // Create Date object from the string
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };






  const handleStartDateChange = (date) => {
    if (date) {
      const formattedDate = format(date, 'MM/dd/yyyy');
      setStartDate(formattedDate);

      setIsStartOpen(false)

    } else {
      setStartDate(null);
    }
  };


  const handleEndDateChange = (date) => {

    if (date) {
      const formattedDate = format(date, 'MM/dd/yyyy');
      setEndDate(formattedDate);

      setIsEndOpen(false)

    } else {
      setEndDate(null);
    }
  };







  const handleDOSDateChange = (date, id) => {
    if (date instanceof Date && !isNaN(date)) {
      const formattedDate = format(date, 'MM/dd/yyyy');
      setSelectDOSDate(prevDates => ({
        ...prevDates,
        [id]: formattedDate
      }));
      setIsDosOpen(prev => ({ ...prev, [id]: false }));
    } else {
      setSelectDOSDate(prevDates => ({ ...prevDates, [id]: null }));
    }
  };







  const getMonths = (selectedYear) => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();

    return Array.from({ length: 12 }, (v, k) => {
      if (selectedYear === currentYear && k > currentMonth) {
        return null;
      }
      return (
        <option key={k} value={k}>
          {format(new Date(selectedYear, k), 'MMMM')}
        </option>
      );
    }).filter(option => option !== null);
  };





  const handleTodayClick = (dateType) => {
    const today = new Date();

    if (dateType === "start" && startDate) {
      setStartDate(today);

      setIsStartOpen(false);
    }

    if (dateType === "end" && endDate) {
      setEndDate(today);
      setIsEndOpen(false);
    }
    if (dateType === "dos" && selectDOSDate) {
      setSelectDOSDate(today);
      setIsDosOpen(false);
    }


  };



  const toggleCalendar = (id, open) => {
    setIsDosOpen(prev => ({ ...prev, [id]: open }));
  };









  const CalendarDOSContainer = ({ children, id }) => (
    <div style={{ zIndex: '999px', backgroundColor: 'white', border: '1px solid lightgray', }}>
      {children}
      <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
        <button type="button" className='today-btn' onClick={() => handleDOSDateChange(new Date(), id)}>
          Today
        </button>
      </div>
    </div>
  );




  const getPatientInsurance = () => {


    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatInsuranceDetails}?PatientId=${id}`;



    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sAuthToken}`
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })

      .then((data) => {

        const parsedData = JSON.parse(data)


        const filterPrimaryIns = parsedData?.filter((item) => item.InsType == 1);
        const filterSecondaryIns = parsedData?.filter((item) => item.InsType == 2);
        setInsurance([
          ...(filterPrimaryIns || []),
          ...(filterSecondaryIns || [])
        ]);

        setSelectedInsurance(filterPrimaryIns);
        setSelectedSecondaryIns(filterSecondaryIns);
        if (selected === "primary") {
          handlePatEligibilityDetails(filterPrimaryIns[0]);
        } else if (selected === "secondary") {
          handlePatEligibilityDetails(filterSecondaryIns[0]);
        }
      })
      .catch((error) => {
        console.error("Error occured while fetching insurance")
      });
  };



  useEffect(() => {
    getPatientInsurance();
    getLocation();
    getAppointment();
    getPA();
  }, []);




  const getAppointment = () => {


    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatientAppointments}?PatientId=${id}`;



    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sAuthToken}`
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })


      .then((data) => {

        const parsedData = JSON.parse(data)
        setAppointmentDetails(parsedData)



      })
      .catch(() => {
        console.error("Error occured while fetching insurance")

      });
  }






  const { todaysAppointment, mostRecentPrevious, mostRecentNext, filteredAppointments } = Appointments({
    appointmentDetails: appointmentDetails,
    isCounselor: 0,
  });
  const { todaysAppointment: counselorTodaysAppointment, mostRecentPrevious: counselorPrevAppointment, mostRecentNext: counselorNextAppointment, filteredAppointments: counselorAppointment } = Appointments({
    appointmentDetails: appointmentDetails,
    isCounselor: 1,
  });




  const getPA = () => {

    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatientPADetails}?PatientId=${id}`;

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sAuthToken}`
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })


      .then((data) => {

        const parsedData = JSON.parse(data)

        setPADetails(parsedData)
      })
      .catch(() => {
        console.error("Error occured while fetching PA details")

      });
  }




  useEffect(() => {
    insurance.forEach(item => {
      if (!selectDOSDate[item.InsTblID]) {
        setSelectDOSDate(prev => ({
          ...prev,
          [item.InsTblID]: new Date().toISOString()
        }));
      }
    });
  }, [insurance]);




  const handleCheckeligibility = async (index, item) => {




    setRowState((prevState) => ({
      ...prevState,
      [insID]: { isLoading: true, isHidden: true, showIcon: true }
    }));



    const selectedDataArray = [];


    setInsID(item.InsTblID);

    setIsLoading(true);

    const eligibilityDOS = item.EligibilityDOS;
    const DOSValue = selectDOSDate[item.InsTblID] || "";


    var InsCountryId = item.PrimaryIns
    if (InsCountryId == null) {
      InsCountryId = ""
    }

    var PayerID = item.InsPayerID
    if (PayerID == null) {
      PayerID = ""
    }


    var inputStruct = {

      "PatientID": id,
      "PracticeID": userPracticeID,
      "PolicyNumber": item.InsPolicyNumber + "",
      "DOS": formatDOSDate(DOSValue) || "",
      "RowIndex": index


    };



    var objPatientDetails = {
      'objPatientDetails': inputStruct
    }
    var myInput = JSON.stringify(objPatientDetails);


    var myInput = JSON.stringify(objPatientDetails);
    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatientEligibility}?sInputJSON=${myInput}`;


    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })

      .then((response) => {
        if (response.status != 200) { }
        else return response.json();
      })


      .then((data) => {


        const responseData = data
        const parsedData = JSON.parse(responseData);


        setRowState((prevState) => ({
          ...prevState,
          [insID]: { isLoading: false, isHidden: false, showIcon: true },
        }));



        var RowIndex = parsedData.RowIndex;
        var InsStatus = parsedData.InsStatus;
        setIsInStatus(parsedData.InsStatus);
        var EligibilityError = parsedData.EligibilityError;




        const payerIDElement = document.querySelector(`.payer${RowIndex}`);




        const filteredClaims = insurance.filter((item) => {
          if (item.InsTblID == insID) {
            if (payerIDElement) {
              if (parsedData.InsStatus === "Active") {
                payerIDElement.style.color = 'green';
              } else {
                payerIDElement.style.color = 'red';
              }
            }
          }


          return true;
        });

        setInsurance(filteredClaims);






      }).catch((error) => {
        console.error('An error occurred:', error);

        setRowState((prevState) => ({
          ...prevState,
          [insID]: { isLoading: false, isHidden: false, showIcon: true },
        }));



      })

  }







  const getLocation = () => {


    const url = `${APIConstants.COMMON_BASE_URL}${CommonAPIConstants.GetLocationDetails}?sInputJSON={"PracticeID":${userPracticeID}}`;

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sAuthToken}`
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })

      .then((res) => {
        const parsedData = JSON.parse(res)


        setLocations(parsedData)
      })
      .catch((err) => {
        console.error("Error occurred while fetching location")
      });
  };











  useEffect(() => {
    getNotes()
    getAlerts()


  }, [patientId, notes])
  // console.log(patientId);










  const getNotes = async () => {

    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatientNotes}?sInputJSON={"PracticeID":${userPracticeID},"PatientID":${id}}`;

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sAuthToken}`
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })

      .then((res) => {

        const parseData = JSON.parse(res)
        setNotes(parseData?.Data.SharedNotes1[0]?.notes)


      })
      .catch((err) => {
        toast.error("Error occurred while fetching location", {
          autoClose: 3000,
        });
      });
  };





  const getAlerts = async () => {
    const date = new Date()

    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatientAlertNotes}?sInputJSON={"PatientID":${id}, "sCurrentWorkingDate":"${date}"}`;

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sAuthToken}`
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then((res) => {
        const parseData = JSON.parse(res)

        setAlerts(parseData?.Data)
      })
      .catch((err) => {
        toast.error("Error occurred while fetching location", {
          autoClose: 3000,
        });
      });
  };





  // Save the Notes Text

  const debounceNotestTimeout = useRef(null);

  const saveNotes = async (notestext, eventName) => {

    setNotes(notestext)

    if (debounceNotestTimeout.current) {
      clearTimeout(debounceNotestTimeout.current);
    }


    debounceNotestTimeout.current = setTimeout(async () => {

      const InputJson = JSON.stringify(JSON.stringify({
        PatientID: id,
        PracticeID: userPracticeID,
        IsShared: 1,
        Notes: notestext,
        noteText: notestext,
        UserID: userPracticeID,
      }));


      try {

        if (eventName.type === "blur") {

          const response = await fetch(APIConstants.PATIENT_PORTAL_URL + CommonAPIConstants.SavePatientNotes, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${sAuthToken}`
            },
            body: InputJson
          });

          const data = await response.json();


        }

        // toast.success("Notes Updated Successfully");
      } catch (error) {
        console.error("Error saving notes:", error);

      }

    }, 500)
  };


  // Save the Alerts Text
  const debounceAleartTimeout = useRef(null);

  const saveAlerts = async (alertText, eventName) => {
    const date = new Date()
    setAlerts(alertText);
    if (debounceAleartTimeout.current) {
      clearTimeout(debounceAleartTimeout.current);
    }


    debounceAleartTimeout.current = setTimeout(async () => {



      const input = JSON.stringify(JSON.stringify({
        PatientID: id,
        PracticeID: userPracticeID,
        IsShared: 1,
        Notes: alertText,
        noteText: alertText,
        UserID: userId,
        sCurrentWorkingDate: date
      }));


      try {

        if (eventName.type === "blur") {
          const response = await fetch(APIConstants.PATIENT_PORTAL_URL + CommonAPIConstants.SavePatientAlertNotes, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${sAuthToken}`
            },
            body: input
          });

          const data = await response.json();
          setIsSaving(true)

          setTimeout(() => {
            setIsSaving(false)
          }, 500);



        }
        // toast.success("Alerts Updated Successfully");
      } catch (error) {
        console.error("Error saving notes:", error);

      }

    }, 500)

  };




  const formatPhoneNumber = (value) => {
    const cleaned = value.replace(/\D/g, '').slice(0, 10);
    const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
    if (!match) return value;
    const [, area, prefix, line] = match;
    let result = '';
    if (area) result = `(${area}`;
    if (prefix) result += `) ${prefix}`;
    if (line) result += `-${line}`;
    return result;
  };





  const handlePhoneInputChange = (e) => {
    const raw = e.target.value.replace(/\D/g, "");
    setIsDuplicate(false);

    if (raw.length <= 10) {
      setCell(formatPhoneNumber(raw));

      if (raw.length < 10) {
        setErrorMessages((prev) => ({
          ...prev,
          cell: "Phone number must be 10 digits",
        }));
      } else {
        setErrorMessages((prev) => ({ ...prev, cell: "" }));
      }
    } else {
      setErrorMessages((prev) => ({
        ...prev,
        cell: "Phone number must be 10 digits",
      }));
    }
  };



  //Save The Patient Contact Number
  const debounceContactTimeout = useRef(null);


  const handleSaveContact = async (field, contact, eventName) => {

    const raw = contact.replace(/\D/g, '');
    if (raw.length === 10) {
      await handleCheckisDuplicatePhoneNumber(raw);
    } else {
      setIsDuplicate(false);
      setIsDuplicateData([]);
    }
    if (raw.length > 10) {
      setErrorMessages((prev) => ({
        ...prev,
        cell: 'Phone number must be 10 digits',
      }));
      return;
    }

    const errorMessage = validateField(field, contact);

    switch (field) {
      case 'cell':
        setCell(formatPhoneNumber(raw));
        setErrorMessages((prev) => ({ ...prev, cell: '' }));
        break;
      case 'address':
        setAddress(contact);
        break;
      case 'zip':
        setZip(contact);
        break;
      default:
        break;
    }

    setErrorMessages((prev) => ({ ...prev, [field]: errorMessage }));

    if (debounceContactTimeout.current) {
      clearTimeout(debounceContactTimeout.current);
    }



    debounceContactTimeout.current = setTimeout(async () => {

      const inputJson = {
        PracticeID: userPracticeID,
        PatientID: id,
        ContactNumber: formatPhoneNumber(raw)
      }


      const sInput = JSON.stringify({ PatInfo: inputJson })
      const JsonInput = JSON.stringify(sInput)

      try {

        if (eventName.type === "blur") {
          const response = await fetch(APIConstants.PATIENT_PORTAL_URL + CommonAPIConstants.SaveContactNumber, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${sAuthToken}`
            },
            body: JsonInput
          });

          const data = await response.json();

          if (data) {

            window.location.reload();
          }
        }


      } catch (error) {
        console.error("Error saving notes:", error);
      }
    }, 500)
  };



  const handleCheckisDuplicatePhoneNumber = async () => {

    const inpuJson = {

      sPhoneNumber: cell,
      sPatientID: id,
      sPracticeID: userPracticeID

    }


    var sInputJSON = JSON.stringify(inpuJson);

    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.CheckisDuplicatePhoneNumber}?sInputJSON=${sInputJSON}`;


    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sAuthToken}`
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {


        console.log("Response of", data.duplicates, data);
        setIsDuplicateData(data.duplicates)

        if (data.totalDuplicates > 0 && Array.isArray(data.duplicates)) {
          setIsDuplicate(true);
          setIsDuplicateData(data.duplicates);
        } else {
          setIsDuplicate(false);
          setIsDuplicateData([]);
        }

      })
      .catch((error) => {
        console.error('Error fetching:', error);
      });
  }





  useEffect(() => {
    handleCheckisDuplicatePhoneNumber();
  }, [cell]);


  //Save The Patient Address
  const debounceAddrtTimeout = useRef(null);


  const handleSaveAddress = async (field, address, eventName) => {

    const errorMessage = validateField(field, address);
    switch (field) {
      case "cell":
        setCell(address);
        break;
      case "address":
        setAddress(address);
        break;
      case "zip":
        setZip(address);
        break;
      default:
        break;
    }

    setErrorMessages((prev) => ({ ...prev, [field]: errorMessage }));

    if (debounceAddrtTimeout.current) {
      clearTimeout(debounceAddrtTimeout.current);
    }



    debounceAddrtTimeout.current = setTimeout(async () => {

      const inputJson = {
        PracticeID: userPracticeID,
        PatientID: id,
        Address: address
      }


      const sInput = JSON.stringify({ PatInfo: inputJson })
      const JsonInput = JSON.stringify(sInput)
      console.log("input of" + CommonAPIConstants.SavePatAddress, JsonInput);


      try {

        if (eventName.type === "blur") {
          const response = await fetch(APIConstants.PATIENT_PORTAL_URL + CommonAPIConstants.SavePatAddress, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${sAuthToken}`
            },
            body: JsonInput
          });

          const data = await response.json();
          if (data) {

            window.location.reload();
          }
          console.log("Response of" + CommonAPIConstants.SavePatAddress, data);

        }


      } catch (error) {
        console.error("Error saving notes:", error);
      }
    }, 500)
  };





  //Save The Patient Address
  const debounceZipTimeout = useRef(null);


  const handleSaveZip = async (field, Zip, eventName) => {

    const normalizedField = field.toLowerCase();
    const errorMessage = validateField(normalizedField, Zip);


    if (errorMessage) {
      setErrorMessages((prev) => ({ ...prev, [normalizedField]: errorMessage }));
      return;
    }

    if (normalizedField === "zip") {
      await handleGeZipDetails(normalizedField, Zip);
    }



    switch (normalizedField) {
      case "cell":
        setCell(Zip);
        break;
      case "address":
        setAddress(Zip);
        break;
      case "zip":
        setZip(Zip);
        break;
      default:
        break;
    }

    setErrorMessages((prev) => ({ ...prev, [normalizedField]: '' }));


    if (debounceZipTimeout.current) {
      clearTimeout(debounceZipTimeout.current);
    }



    debounceZipTimeout.current = setTimeout(async () => {

      const inputJson = {
        PracticeID: userPracticeID,
        PatientID: id,
        Zip: Zip
      }


      const sInput = JSON.stringify({ PatInfo: inputJson })
      const JsonInput = JSON.stringify(sInput)
      console.log("input of" + CommonAPIConstants.SaveZipDetails, JsonInput);


      try {

        if (eventName.type === "blur") {
          const response = await fetch(APIConstants.PATIENT_PORTAL_URL + CommonAPIConstants.SaveZipDetails, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${sAuthToken}`
            },
            body: JsonInput
          });

          const data = await response.json();
          if (data) {

            window.location.reload();
          }
          console.log("Response of" + CommonAPIConstants.SaveZipDetails, data);

        }


      } catch (error) {
        console.error("Error saving notes:", error);
      }
    }, 500)
  };




  const handleGeZipDetails = async (field, Zip) => {
    if (field !== "zip") return;

    try {
      const zipPayload = JSON.stringify({ zipcode: Zip });
      const response = await fetch(APIConstants.BASE_URL + CommonAPIConstants.GetZipDetails, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: zipPayload
      });

      const zipData = await response.json();
      const parsedData = JSON.parse(zipData.d);

      if (parsedData && parsedData.cityName && parsedData.StateShortDesc) {

        console.log("CITY >>>>>>>>>>>>>>", parsedData, parsedData.StateShortDesc);

        setCity(parsedData.cityName);
        setStateName(parsedData.StateShortDesc);
        setZipError('');
      } else {
        setCity('');
        setStateName('');
        setZipError('Incorrect Zipcode');
      }
    } catch (zipError) {
      console.error("Error fetching city/state:", zipError);
      setZipError('Invalid ZIP');
      setCity('');
      setStateName('');
    }
  };




  const validateField = (field, value) => {
    const raw = value.replace(/\D/g, '');

    switch (field.toLowerCase()) {
      case 'cell':
        return raw.length === 10 ? '' : 'Phone number must be 10 digits';

      case 'zip':
        return /^\d{5}$/.test(value) ? '' : 'Zip code must be exactly 5 digits';

      case 'address':
        return value.trim().length >= 5
          ? ''
          : 'Address must be at least 5 characters long';

      default:
        return '';
    }
  };



  const toggleMenu = () => {
    setIsOpen(false)
  }




  const handlePatEligibilityDetails = (item) => {
    setPayerData("");
    setReceiverData("");
    setSubscriberData("");
    setBenefitData("");
    setobjPatData("");
    setAddiSubscriberData("");
    setCoInsurance("");
    setCoPayment("");
    setDeductibleDta("");
    setobjProviderData("");
    var jsoninput = {
      PatientID: patientId,
      InsCompanyID: item?.InsCoID,
      PolicyNumber: item?.InsPolicyNumber,
      UserID: userData ? userData.userID : 0,
      DOS: userData ? (formatDOSDate(userData.dtCurrentWorkingDate)) : ""
    };
    var inputJSON = JSON.stringify({ objPatientDetails: jsoninput });
    //const url = `${APIConstants.PATIENT_PORTAL_URL}PatientInsuranceDetails/EligibilityDetails?sInputJSON=${inputJSON}`;
    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.PatientEligibilityDetails}?sInputJSON=${inputJSON}`;
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${sAuthToken}`,
      },
    })
      .then((response) => {
        if (response.status != 200) {
          // console.log("response.status", response.status);
        } else return response.json();
      })
      .then((data) => {
        const parsedData = JSON.parse(data);
        setPayerData(parsedData.objPayer);
        setReceiverData(parsedData.objReceiver);
        setSubscriberData(parsedData.objSubscriber);
        setBenefitData(parsedData.objBenefit);
        setobjPatData(parsedData.objPatient);
        setAddiSubscriberData(parsedData.objSubAddtlInfo);
        setCoInsurance(parsedData.objCoInsurace);
        setCoPayment(parsedData.objCopayment);
        setDeductibleDta(parsedData.objDeductible);
        setobjProviderData(parsedData.ojbProvider);
      })

      .catch((error) => {
        console.error("Error fetching Insurance names:", error);
      });
  };



  const handleUpdateLocation = async (e) => {
    const selectedValue = e.target.value
    setSelectedLocation(selectedValue);

    const inpuJson = {

      sPatID: DemoGraphyData.PatientId,
      sAppDate: formatDOSDate(userData.dtCurrentWorkingDate),
      sPatLoc: selectedValue,
      sPracticeID: userPracticeID,
      sUserID: userId,
      sUserFullName: userData.userFullName,
      sUserRole: userData.roleID,


    }

    const myInput = JSON.stringify(inpuJson);
    const inputData = JSON.stringify(myInput)

    try {
      const response = await fetch(APIConstants.BASE_URL_APPOINTMENT_MS + CommonAPIConstants.UpdatePatLocation, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sAuthToken}`,

        },
        body: inputData
      })



      if (response.status !== 200) {
        console.log("Error: Received response status", response.status);
        return;
      }



      const responseData = await response.json();
      if (responseData) {

        window.location.reload();
      }




    } catch (error) {
      console.error('An error occurred:', error);
    }
  };


  const handleChange = (field, value) => {
    const errorMessage = validateField(field, value);
    switch (field) {
      case "cell":
        setCell(value);
        break;
      case "address":
        setAddress(value);
        break;
      case "zip":
        setZip(value);
        break;
      default:
        break;
    }
    setErrorMessages((prev) => ({ ...prev, [field]: errorMessage }));

    // Skip autoSave if there’s a validation error
    if (!errorMessage) {
      // initializeAutoSave(field);
      autoSaveRefs.current[field](value);
    } else {
      // Optionally, update save status to indicate the error
      setSaveStatus((prev) => ({ ...prev, [field]: "error" }));
    }
  };



  const GetPDF = (item) => {

    const url = item.DocWebPath;
    window.open(url, '_blank');

  };





  const retrySave = (field) => {
    autoSaveRefs.current[field]?.flush();
  };

  if (!id) {
    return <div className="position-absolute flex flex-col items-center justify-center p-6 bg-red-100 border border-red-300 rounded-lg shadow-md mx-auto my-8 w-full max-w-md">
      <h2 className="text-lg font-semibold text-red-700 mb-2">
        No Patients Available
      </h2>
      <p className="text-sm text-red-600 mb-4 ">
        Patient ID is missing. Please provide a valid Patient ID.
      </p>
    </div>
  }





  return (
    <>

      <div className=" border-r-2 border-blue-400">
        <div style={{ marginLeft: '10px', marginTop: '10px', width: '450px' }} className="col-span-2 border-l-2 border-blue-400">


          <h3 className="bg-red-500 text-white col-span-2 text-lg py-1 text-center">Alert !</h3>
          <textarea
            rows="4"
            cols="44"
            className="border border-black m-1 rounded-md text-red-600 w-100"
            defaultValue={alerts}
            onBlur={(e) => saveAlerts(e.target.value, e)}
          />

          {isSaving && <div>Saving...</div>}
          <h3 className="bg-blue-500 text-white col-span-2 text-lg p-1 ">
            Insurance
          </h3>
          <div className="p-1 overflow-auto">
            <table className="table table-striped table-bordered responsive ">
              <thead>
                <tr className="bg-blue-400 border-b text-white">
                  <th style={{ whiteSpace: "nowrap", backgroundColor: '#0173b7' }} className="p-2 border-r text-white ">
                    #
                  </th>
                  <th style={{ whiteSpace: "nowrap", backgroundColor: '#0173b7' }} className="p-2 border-r text-white">
                    Type
                  </th>
                  <th style={{ whiteSpace: "nowrap", backgroundColor: '#0173b7' }} className="p-2 border-r text-white ">
                    Insurance
                  </th>
                  <th style={{ whiteSpace: "nowrap", backgroundColor: '#0173b7' }} className="p-2 border-r text-white">
                    Policy
                  </th>
                  <th style={{ whiteSpace: "nowrap", backgroundColor: '#0173b7' }} className="p-2 border-r text-white">
                    DOS
                  </th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(insurance) && insurance?.length > 0 ? insurance.map((item, index) => {
                  return (
                    <tr key={index} className="border-b ">
                      <td style={{ whiteSpace: "nowrap" }} className=" border-r p-2">
                        {index + 1}
                      </td>
                      <td style={{
                        backgroundColor:
                          item?.InsType === "1"
                            ? "#f1f1c4"
                            : item?.InsType === "2"
                              ? "#cbd9f3"
                              : "",
                      }} className=" border-r p-2">

                        {item?.InsType === "1" && "Primary"}
                        {item?.InsType === "2" && "Secondary"}
                      </td>
                      <td style={{ width: '120px' }} >
                        {item?.InsCoName}
                      </td>
                      <td style={{
                        whiteSpace: "nowrap",
                        backgroundColor:
                          item?.PatInsStatus === "active" || item?.EligibilityResp === "success"
                            ? "#c9f597"
                            : item?.PatInsStatus === "inactive" || item?.EligibilityResp !== ""
                              ? "#f78181"
                              : "",
                      }}
                        className={`payer${index} 'table-success'}`}>
                        {item?.InsPolicyNumber} <br></br>

                      </td>
                      <td style={{
                        backgroundColor:
                          item?.PatInsStatus === "active" || item?.EligibilityResp === "success"
                            ? "#c9f597"
                            : item?.PatInsStatus === "inactive" || item?.EligibilityResp !== ""
                              ? "#f78181"
                              : "",
                      }}>
                        <DatePicker

                          selected={selectDOSDate[item.InsTblID] ? new Date(selectDOSDate[item.InsTblID]) : new Date()}
                          onChange={(date) => handleDOSDateChange(date, item.InsTblID)}
                          dateFormat="MM/dd/yyyy"
                          maxDate={new Date()}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          yearDropdownItemNumber={100}
                          className={`clnImgTextBoxes ${selectDOSDate ? 'default-selected' : ''}`}
                          placeholderText="MM/dd/yyyy"
                          popperPlacement="bottom-start"

                          calendarContainer={(props) => <CalendarDOSContainer {...props} id={item.InsTblID} />}

                          open={isDosOpen[item.InsTblID] || false}
                          onFocus={() => toggleCalendar(item.InsTblID, true)}
                          onInputClick={() => toggleCalendar(item.InsTblID, true)}
                          onClickOutside={() => toggleCalendar(item.InsTblID, false)}
                          renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                            const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                            const selectedMonth = selectedDate.getMonth();
                            const selectedYear = selectedDate.getFullYear();

                            return (
                              <div>
                                <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px' }}>
                                  {"<"}
                                </button>
                                <select
                                  value={selectedMonth}
                                  onChange={({ target: { value } }) => changeMonth(Number(value))}
                                >
                                  {getMonths(selectedYear)}
                                </select>
                                <select
                                  value={selectedYear}
                                  onChange={({ target: { value } }) => changeYear(Number(value))}
                                >
                                  {Array.from({ length: 100 }, (v, k) => (
                                    <option key={k} value={new Date().getFullYear() - k}>
                                      {new Date().getFullYear() - k}
                                    </option>
                                  ))}
                                </select>
                                <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px' }}>
                                  {">"}
                                </button>
                              </div>
                            );
                          }}
                        />
                        <button className='diagbtn-style' style={{ marginLeft: '10px' }} onClick={(e) => handleCheckeligibility(index, item)}>Check</button>
                        {rowState[item.InsTblID]?.isHidden && (
                          <FontAwesomeIcon
                            style={{ marginLeft: '5px' }}
                            icon={faSpinner}
                            className={rowState[item.InsTblID]?.isLoading ? 'rotating-icon' : ''}
                          />
                        )}
                      </td>
                    </tr>
                  );
                }) : <tr>No insurance found</tr>}
              </tbody>
            </table>
          </div>
          <h3 className="bg-blue-500 text-white col-span-2 text-lg p-1">
            Appointments :
          </h3>
          <h3 className="bg-gray-300 text-blue-500 rounded-sm text-xl">
            Next : {mostRecentNext ? `${extractDate(mostRecentNext?.AppointmentDate)} | ${mostRecentNext?.AppointmentTime}` : null}
          </h3>
          <h3 className="bg-yellow-200 text-gray-800 rounded-sm text-xl">Current : {todaysAppointment ? `${extractDate(todaysAppointment?.AppointmentDate)} | ${todaysAppointment?.AppointmentTime}` : null}</h3>
          <h3 className="bg-gray-200 text-gray-500 rounded-sm text-xl">
            Previous : {mostRecentPrevious ? `${extractDate(mostRecentPrevious?.AppointmentDate)} | ${mostRecentPrevious?.AppointmentTime}` : null}
          </h3>

          <h3 className="bg-orange text-white text-xl">Counselor Appointments :</h3>
          <h3 className="bg-gray-300 text-blue-700 rounded-sm text-xl">
            Next : {counselorNextAppointment ? `${extractDate(counselorNextAppointment?.AppointmentDate)} | ${counselorNextAppointment?.AppointmentTime}` : null}
          </h3>
          <h3 className="bg-yellow-200 text-gray-800 rounded-sm text-xl">Current : {counselorTodaysAppointment ? `${extractDate(counselorTodaysAppointment?.AppointmentDate)} | ${counselorTodaysAppointment?.AppointmentTime}` : null}</h3>
          <h3 className="bg-gray-200 text-gray-500 rounded-sm text-xl">
            Previous : {counselorPrevAppointment ? `${extractDate(counselorPrevAppointment?.AppointmentDate)} | ${counselorPrevAppointment?.AppointmentTime}` : null}
          </h3>

          <h3 className="bg-blue-500 text-white p-1 text-lg">DM :</h3>
          <form className="grid grid-cols-3 bg-blue-100">

            <div className="text-md font-medium">Location:</div>
            <div className="col-span-2">

              <select name="select" className="py-1 px-2 border border-gray-400 rounded-md w-3/4 my-1"
                value={selectedLocation}
                onChange={(e) => handleUpdateLocation(e)}>

                {locations.map((item, index) => (
                  <option style={{ width: "100px" }} value={item.LocationId} key={index}>{item.LocationNickname}</option>

                ))}
              </select>

            </div>
            <div className="text-md font-medium">Cell : #</div>
            <div className="col-span-2">

              <div className="tooltip-container w-3/4 my-1">
                <input
                  type="text"
                  className={`py-1 px-2 border border-gray-400 rounded-md w-full ${isDuplicate && cell.replace(/\D/g, '').length === 10 ? "bg-red-500" : ""
                    }`}
                  value={cell}
                  onChange={handlePhoneInputChange}
                  onBlur={(e) => handleSaveContact("cell", e.target.value, e)}
                  maxLength={14}
                />

                {isDuplicate && cell.replace(/\D/g, '').length === 10 && isDuplicateData.length > 0 && (
                  <div className="custom-tooltip">
                    <strong>Duplicate Phone Number</strong>
                    <hr />
                    {isDuplicateData.map((item, index) => {
                      const fname = item.firstName?.trim() || "";
                      const lname = item.lastName?.trim() || "";
                      return (
                        <div key={index} className="tooltip-name">
                          {lname} {fname}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>


              {errorMessages.cell && (
                <div className="text-red-500 text-sm">{errorMessages.cell}</div>
              )}
            </div>
            <div className="text-md font-medium">Address1 :</div>
            <div className="col-span-2">
              <input
                type="text"
                className="py-1 px-2 border border-gray-400 rounded-md w-3/4 my-1"
                defaultValue={address}
                onBlur={(e) => handleSaveAddress("address", e.target.value, e)}
              />

              {errorMessages.address && (
                <div className="text-red-500 text-sm">
                  {errorMessages.address}
                </div>
              )}
            </div>
            <div className="text-md font-medium">Zip Code :</div>
            <div className="col-span-2">
              <input
                type="text"
                className="py-1 px-2 border border-gray-400 rounded-md w-3/4 my-1"
                defaultValue={zip}
                maxLength={5}
                onBlur={(e) => handleSaveZip("zip", e.target.value.trim(), e)}
              />

              {errorMessages.zip && (
                <div className="text-red-500 text-sm">{errorMessages.zip}</div>
              )}
            </div>

            <div className="flex items-center space-x-4 mt-4">
              <div className="flex items-center space-x-2">
                <label className="whitespace-nowrap">City:</label>
                <input
                  type="text"
                  className="py-1 px-2 border border-gray-400 rounded-md bg-gray-100 w-40"
                  value={city}
                  disabled
                />
              </div>

              <div className="flex items-center space-x-2">
                <label className="whitespace-nowrap">State:</label>
                <input
                  type="text"
                  className="py-1 px-2 border border-gray-400 rounded-md bg-gray-100 w-40"
                  value={stateName}
                  disabled
                />
              </div>
            </div>


            {zipError && <p className="text-red-500 text-sm">{zipError}</p>}

          </form>

          <h3 className="bg-blue-500 text-white p-1 text-lg">Login :</h3>
          <div className="grid grid-cols-3">
            <div className="text-md font-medium">Username</div>
            <div className="col-span-2">
              <input
                type="text"
                className="py-1 px-2 border border-gray-400 rounded-md w-3/4 my-1"
              />
            </div>
            <div className="text-md font-medium">Password</div>
            <div className="col-span-2 flex flex-row items-center justify-start gap-2">
              <input
                type={isShowPswd ? "text" : "password"}
                className="py-1 px-2 border border-gray-400 rounded-md w-3/4 my-1 cursor-pointer"
              />

              {isShowPswd ? (

                <FontAwesomeIcon className='fa'
                  icon={faEyeSlash}
                  aria-hidden="true"
                  onClick={() => {
                    setIsShowPswd(!isShowPswd)
                  }}
                  style={{ cursor: 'pointer' }}

                />
              ) : (
                <FontAwesomeIcon className='fa'
                  icon={faEye}
                  aria-hidden="true"
                  onClick={() => {
                    setIsShowPswd(!isShowPswd)
                  }}
                  style={{ cursor: 'pointer' }}

                />
              )}
            </div>
            <div className="text-md font-medium">Email</div>
            <div className="col-span-2">
              <input
                type="email"
                className="py-1 px-2 border border-gray-400 rounded-md w-3/4 my-1 mr-1"
              />
              <button title="Save" />
            </div>
          </div>

          <h3 className="bg-blue-500 text-white text-lg p-1">Notes :</h3>
          <textarea
            rows="4"
            cols="44"
            className="border border-black m-1 rounded-md w-96"
            defaultValue={notes}
            onBlur={(e) => saveNotes(e.target.value, e)}
          />
          {/* {isSaving && <div>Saving...</div>} */}

          <h3 className="bg-blue-500 text-white text-lg p-1" onClick={getPA}>PA :</h3>
          <div className="overflow-x-scroll w-full p-1">
            <table>
              <thead>
                <tr className="bg-blue-400 border-b text-white">
                  <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                    Sent Date
                  </th>
                  <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                    Recieved Date
                  </th>
                  <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                    Type
                  </th>
                  <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                    Expiry Date
                  </th>
                  <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                    Updated By
                  </th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(PADetails) && PADetails?.length > 0 ? PADetails.map((item, index) => {
                  return (
                    <tr key={index} className="border-b">
                      <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                      </td>
                      <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                      </td>
                      <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                        {item?.FileNotes}
                      </td>
                      <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                        {item.FileExpiryDate}
                      </td>
                      <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                        <FontAwesomeIcon style={{ marginLeft: '10px', color: 'red' }} onClick={() => GetPDF(item)} icon={faFilePdf} />
                        {item.UpdatedBy}
                      </td>
                    </tr>
                  )
                }) : <>No results!</>}
              </tbody>
            </table>
          </div>
          <div className="bg-blue-500 text-white flex flex-row items-center p-1 justify-between text-lg">
            Text :(968) 968-9680
            <button title="Send Now" />
          </div>
          <textarea
            rows="4"
            cols="44"
            className="border border-black m-1 rounded-md w-96"
          />
          {/* </div> */}
        </div>

      </div>
    </>
  );
};

export default AppointmentSection;
